export const environmentversion = {
  version : 'origin/master(a80f669ea64f34f76a3b72c61b07d2ad6cf44773)'
};